import { getKeys } from './getKeys'

export const carePlansTranslations = {
	ERROR_FLUID_TARGET_CAN_NOT_BE_EMPTY: 'Fluid target can not be empty',
	ERROR_INVALID_CHARACTER: 'Invalid character',
	ERROR_FLUID_TARGET_CAN_NOT_BE_0: 'Fluid target can not be 0',
	ERROR_CORRECT_AMOUNT: 'Make sure you have typed the correct amount',
	FLUID_TRACKING: 'Fluid tracking',
	DISABLE: 'Disable',
	ENABLE: 'Enable',
	FIND_OUT_MORE: 'Find out more',
	DAILY_INTAKE_TARGET: 'Daily intake target',
	SELECT_NEEDS: 'Select Needs',
	CHOOSE_FORM_LIST: 'Choose from list',
	NO_CURRENT_TARGET: 'No current target',
	DAILY_INTAKE_TARGET_ML: 'Daily intake target of {{intakeTarget}}ml',
  } 

export const carePlansConstants = getKeys(carePlansTranslations)
  